import { FunnelVariableDto } from 'api/funnel';
import { ExpressionVariable } from './components/expression/ExpressionBuilder';

/**
 * Variables du tunnel proposées par le constructeur de formule.
 *
 * Le contenu des modales est rendu hors du provider de la page (portail de l'overlay) :
 * la liste est donc passée explicitement en propriété plutôt que lue dans un contexte.
 */
export const toExpressionVariables = (
  variables?: FunnelVariableDto[] | null
): ExpressionVariable[] =>
  (variables ?? [])
    .map((item) => ({
      code: item.variable?.code ?? '',
      libelle: item.variable?.libelle || item.variable?.code || '',
      unite: item.unite || undefined,
    }))
    .filter((variable) => variable.code)
    .sort((a, b) => a.libelle.localeCompare(b.libelle, 'fr'));
